import { organizationsForCommitmentsSelector } from "./organizationsForCommitmentsSelector";
import { RootState } from "../../../store";

export const connectedOrganizationExistsSelector = (state: RootState) => {
  const orgs = organizationsForCommitmentsSelector(state);
  return (orgs?.filter((org) => org.cloud_provider === "aws")?.length ?? 0) > 0;
};
